import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './index.scss';
import { Popup } from '../../Popup';

const closeImg = require('../../../../assets/images/close-modal.svg');

const TooltipModal = ({ heading, children, onClose }) => (
    <Popup onClose={onClose}>
        <div className={styles.modalContainer}>
            <div className={styles.modalHeader}>
                <p className={styles.modalHeaderText}>{heading ? <FormattedMessage id={heading} /> : null}</p>
                <button onClick={onClose} className={`${styles.modalCloseButton} iconButton`}>
                    <img alt="close" src={closeImg} className={styles.modalCloseIcon} />
                </button>
            </div>
            <div className={`${styles.modalContent} custom-list`}>{children}</div>
        </div>
    </Popup>
);

TooltipModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    heading: PropTypes.string,
    children: PropTypes.node,
};

TooltipModal.defaultProps = {
    heading: '',
    children: null,
};

export default TooltipModal;
